<script setup>
defineProps({
  src: {
    type: String,
    required: true,
    default() {
      return ''
    },
  },

  alternativeText: {
    type: String,
    required: false,
    default: '',
  },

  width: {
    type: [Number, String],
    required: false,
    default: null,
  },

  height: {
    type: [Number, String],
    required: false,
    default: null,
  },

  cover: {
    type: Boolean,
    required: false,
    default: false,
  },

  contain: {
    type: Boolean,
    required: false,
    default: false,
  },

  fetchpriority: {
    type: String,
    required: false,
    default: null,
  },

  lazy: {
    type: Boolean,
    required: false,
    default: true,
  },

  autoplay: {
    type: Boolean,
    required: false,
    default: true,
  },

  file: {
    type: Object,
    required: false,
    default() {
      return {}
    },
  },
})
</script>

<template>
  <div>
    <video
      :width="width"
      :height="height"
      :autoplay="autoplay"
      :muted="autoplay"
      :loop="autoplay"
      :controls="!autoplay"
      :class="{
        'absolute inset-0 h-full w-full object-cover': cover,
        'absolute inset-0 h-full w-full object-contain': contain,
      }"
      :loading="lazy ? 'lazy' : null"
      :fetchpriority="fetchpriority"
      playsinline
    >
      <source :src="src" :type="file.mime" />
    </video>
  </div>
</template>
